<template>
  <div class="message-container">
    <div name="messages-list">
      <div
        v-for="message in messages" :key="message.id"
        :title="title(message)"
        class="message"
      >
        <div :class="['status', statusClass(message)]"></div>
        <div class="username">{{ message.username }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Dates from '../../services/dates'

export default {
  props: {
    messages: Array,
    failure_statuses: Object,
  },
  methods: {
    readableDate (timestamp) {
      return Dates.longFormat(Dates.parseDate(timestamp))
    },
    title (message) {
      let title = this.readableDate(message.updated_at)
      if (message.failures.length) {
        message.failures.forEach(failure => {
          if (failure.failure_type in this.failure_statuses) {
            title += ' ' + this.failure_statuses[failure.failure_type].title
          } else {
            title += ' ' + failure.failure_type
          }
        })
      }
      return title
    },
    statusClass (message) {
      if (message.failures.length) {
        const failure = message.failures[0]
        if (failure.failure_type in this.failure_statuses) {
          return this.failure_statuses[failure.failure_type].status_class
        }
      }
      return message.delivery_status
    }
  }
}
</script>



// WEBPACK FOOTER //
// MessageGroupList.vue?8f5c2a64